import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useValidateOfferStageChange = function (id) {
    return useApiCall(function (signal, id, payload) {
        return api.offer.apiOfferDataStageChangeAllowedGet(id, payload, { signal: signal });
    }, null, !!id, [id]);
};
